<template>
  <v-flex fill-height lg12 md12>
    <v-card class="fill-height">
      <v-toolbar color="secondary" dense>
        <v-toolbar-title class="primarytext--text">Spese protocolate mensile</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-tooltip bottom open-delay="10" close-delay="10">
            <v-btn 
              dark
              flat 
              icon
              :disabled="!date"
              slot="activator"
              @click.stop="riepilogoHandler"
              >
             <v-icon color="primarytext--text">fa-file-excel</v-icon>
            </v-btn>
            <span>Scarica riepilogo</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout row wrap align-center justify-space-around>
          <v-flex align-self-start shrink pt-3>
            <v-date-picker
              v-model="date"
              :events="nonProtocollate"
              event-color="error"
              :allowed-dates="allowedMonths"
              type="month"
              color="secondary lighten-1"
              locale="it-IT"
              :max="$moment().format('YYYY-MM')"
              @input="getReport"
              class="elevation-0"
            ></v-date-picker>
          </v-flex>
          <!--<v-divider inset></v-divider>-->
          <v-flex v-if="!!date" xs12 sm12 md8 lg8 align-self-start>
            <v-container fluid grid-list-md class="scroll-y">
              <v-data-iterator
                hide-actions
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                content-tag="v-list"
                content-class="v-list--three-line layout align-center justify-center row wrap fill-height"
                column
              >
                <v-flex
                  slot="no-data"
                  align-self-center
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >Nessuna spesa nella data selezionata!</v-flex>
                <v-flex slot="item" slot-scope="props" class="xs12 sm12 md8 lg8" transition="slide-y-transition">
                    <ReportRowItem
                      :item="props.item"
                      @on-click-protocollare="showProtocollo"
                    ></ReportRowItem>
                </v-flex>
              <template v-if="items.length > 0" slot="footer">
                  <v-layout align-center justify-center row>
                    <v-toolbar
                      class="flex xs12 sm12 md8 lg8"
                      dense
                      flat
                    >
                        <v-toolbar-items class="secondary--text justify-center align-center">
                            <v-layout align-start justify-center column>
                                <v-badge v-if="qNonProtocallato > 0" left color="pink" class="mb-2">
                                    <template slot="badge">
                                      <span v-text="qNonProtocallato"></span>
                                    </template>
                                    <span>Non protocollate</span>
                                  </v-badge>
                                <v-badge v-if="qProtocallato > 0" left color="blue">
                                    <template slot="badge">
                                      <span v-text="qProtocallato"></span>
                                    </template>
                                    <span>Protocollate</span>
                                  </v-badge>
                          </v-layout>
                        </v-toolbar-items>
                        <v-spacer></v-spacer>
                      <v-toolbar-title class="headline">Totale: {{total}} €</v-toolbar-title>
                    </v-toolbar>
                  </v-layout>
                </template>
              </v-data-iterator>
              <div class="text-xs-center pt-2" v-if="pages > 1">
                <v-pagination v-model="pagination.page" :length="pages" color="secondary"></v-pagination>
              </div>
            </v-container>
          </v-flex>
          <v-flex
            v-else
            xs12
            sm8
            md8
            lg8
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Seleziona il mese delle spese!</v-flex>
        </v-layout>
      </v-layout>
    </v-card>
      
    <ProtocolloAnteprima
      :data="protocolloData"
      :isShow="protocolloAnteprimaModale"
      @on-close="closeProtocolloAnteprimaHandler"
      @on-donwload="downloadProtocolloFileHandler"
      @on-confirm="confirmProtocolloFileHandler"
    ></ProtocolloAnteprima>
  </v-flex>

</template>

<script>
import XLSX from "xlsx";
import { saveAs } from 'file-saver'
import ProtocolloAnteprima from "./ProtocolloAnteprima.vue";
import ReportRowItem from "./ReportRowItem.vue";
import { DownloadFile } from "../services/helper";

export default {
  name: "acc-report-mensile",
  components: {ProtocolloAnteprima, ReportRowItem},
  props: {},
  data() {
    return {
      loader: false,
        date: null,
        rowsPerPageItems: [4, 8, 12],
        pagination: {
          rowsPerPage: 4
        },
        codice: null,
        protocolloAnteprimaModale: false,
        protocolloData: null,
    };
  },
  watch: {
      date(val) {
          this.$store.commit("report/SET_DATE", this.date)
      }
  },
  computed: {
    items() {
      return this.$store.getters["report/mensile"];
    },
    nonProtocollate() {
      return this.$store.getters["report/nonProtocollate"];
    },
    pages() {
      return Math.ceil(this.items.length / this.pagination.rowsPerPage);
    },
    total() {
      let tot = this.items.map(itm => +itm.totale).reduce((a, b) => {
        return a + b
      }, 0)
      return tot.toFixed(2)
    },
    qProtocallato() {
      return this.items.map(itm => {
          return (+itm.protocolato_mensile || 0) + (+itm.protocolato_integrato || 0)
      }).reduce((a, b) => {
        return a + b
      }, 0)
    },
    qNonProtocallato() {
      return this.items.map(itm => {
          var q = 0
          if (typeof itm.protocolato_mensile !== 'undefined') q++
          if (typeof itm.protocolato_integrato !== 'undefined') q++
          return q
      }).reduce((a, b) => {
        return a + b
      }, 0) - this.qProtocallato
    }
  },
  created() {
      this.$store.dispatch("report/checkNonProtocollate")
  },
  methods: {
    allowedMonths: val => val,
    getReport: function(e) {
      this.$store.dispatch("report/getMensile", { data: this.date })
    },
    showProtocollo(data) {
        data.protocollata 
        ? this.showAnteprimaProtocollo(data)
        : this.$store
          .dispatch("report/beforeProtocollaSpesa", {
            spesa_id: data.spesa_id
          })
          .then(res => {
            if (res.stato === "success") {
              this.protocollaSpesa(data.spesa_id)
            } else {
                this.$swal({
                    type: 'warning',
                    html: `<h1 class="font-weight-regular">Attenzione!</h1>  <h3 class="font-weight-light">La spesa che va protocollata contiene ${res.data} note non confermate. <br> Sicure si volere continuare?</h3> <br><h5 class="font-weight-regular">* Nel caso continue: nuove spese vanno aggiunte come integrazione nel mese prossimo!</h5>`,
                    showCancelButton: true,
                    cancelButtonText: 'Attermina',
                    showConfirmButton: true,
                    confirmButtonText: 'Continua',
                }).then(resp => {
                    if (resp.value)
                        this.protocollaSpesa(data.spesa_id)
                })
            }
          });
    },
    protocollaSpesa(spesa_id) {
        this.$store
          .dispatch("report/getProtocolloSpesa", {
            spesa_id: spesa_id
          })
          .then(res => {
            if (res.stato === "success") {
              this.showAnteprimaProtocollo(res.data);
            }
          });
    },
    showAnteprimaProtocollo(data) {
      this.protocolloAnteprimaModale = true;
      this.protocolloData = data;
    },
    closeProtocolloAnteprimaHandler() {
      this.protocolloAnteprimaModale = false;
      this.protocolloData = null;
    },
    confirmProtocolloFileHandler() {
        this.$swal({
            type: 'question',
            html: `Sicuro di voler protocollare la spesa?</h3> <br><h5 class="font-weight-regular">* In caso positivo, le nuove spese verranno aggiunte ad integrazione del mese prossimo!</h5>`,
            showCancelButton: true,
            cancelButtonText: 'Cancella',
            showConfirmButton: true,
            confirmButtonText: 'Protocolla',
        }).then(resp => {
            if (resp.value) {
                this.$store
                  .dispatch("report/protocollaSpesa", {
                    spesa_id: this.protocolloData.spesa_id
                  })
                  .then(res => {
                    if (res.stato === "success") {
                        this.downloadProtocolloFileHandler()
                    }
                  });
            }
        })        
    },
    downloadProtocolloFileHandler() {
        DownloadFile(
            this.protocolloData.file,
            this.protocolloData.protocolName
        );
        this.protocolloAnteprimaModale = false;
        this.protocolloData = null;     
    },
    riepilogoHandler() {
      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Riepilogo del " + this.$moment().format('MMMM'),
        Subject: "Rimborsi",
        Author: "Accueil"
      };
        
      wb.SheetNames.push("Riepilogo");
      const ws_data = [
        ['Somma di IMPORTO DA BONIFICARE'],
        ['NOME COLLABORATORE', 'Totale']
      ];
      let totale = 0;
      this.items.forEach(itm => {
        totale += Number(itm.totale);
        ws_data.push([itm.nome_utente, Number(itm.totale).toFixed(2)]);
      });
      ws_data.push(['Totale complessivo', totale.toFixed(2)]);
      
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      for(const k in ws) {
        if (!isNaN(ws[k].v)) {
          ws[k].t = 'n';
        }        
      }
      
      wb.Sheets["Riepilogo"] = ws;
      const wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) {  
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;                
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), "Riepilogo del " + this.$moment().format('MMMM YYYY') + '.xlsx');

    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabReportMensile.vue